import React, { FC } from 'react';
import AppPageLayout from 'layout/AppPagelayout';
import { ContentColors, PhoneFrame, Switch } from 'components';
import { useConfigUsage } from 'provider/hooks/SvaraConfigHook';
import { colorUsage } from 'provider/context/defaultData';
import { createContentColorsItems } from 'utils/Colors';
import { ContentColorsItem } from 'components/AppPage/types';
import { Tabbar } from 'components/Applications';
import { SearchBar } from 'components/Applications/search';
import { SectionSquare } from 'components/Applications/sections';

const searchColor = [
    colorUsage.tab_layout_home,
    colorUsage.search_page_field,
    colorUsage.search_page_icon,
    colorUsage.search_page_text,
];

const Search: FC = () => {
    const phoneWidth = '236px';
    const { isDark, setDark, getColor, hasDarkLightVarian } = useConfigUsage();

    const getColorsToShow = React.useCallback((): ContentColorsItem[] => {
        return createContentColorsItems(
            searchColor,
            isDark,
            getColor,
            hasDarkLightVarian
        );
    }, [getColor, hasDarkLightVarian, isDark]);

    return (
        <AppPageLayout>
            <div className="w-full flex overflow-x-hidden relative">
                <div
                    className={`overflow-hidden p-4`}
                    style={{
                        width: `calc(100vw - ${phoneWidth})`,
                    }}
                >
                    <ContentColors contents={getColorsToShow()} />
                </div>
                <div
                    className={`flex grow-0 mx-4`}
                    style={{
                        width: phoneWidth,
                    }}
                >
                    <div className="flex flex-col fixed top-toolbar right-4 mt-4 gap-y-2">
                        <PhoneFrame
                            width={phoneWidth}
                            withoutMiniPlayer
                            transparentStatusBar
                            tabbar={<Tabbar activeAt="search" />}
                        >
                            <SearchBar />
                            <SectionSquare />
                            <SectionSquare />
                        </PhoneFrame>

                        <Switch
                            active={isDark}
                            onChange={setDark}
                            activeText="Dark"
                            offText="Light"
                            removeColorActive={false}
                            size="lg"
                        />
                    </div>
                </div>
            </div>
        </AppPageLayout>
    );
};

export default Search;
